import { render, staticRenderFns } from "./CreateProductType.vue?vue&type=template&id=135eb0eb&lang=pug&"
import script from "./CreateProductType.vue?vue&type=script&lang=ts&"
export * from "./CreateProductType.vue?vue&type=script&lang=ts&"
import style0 from "./CreateProductType.vue?vue&type=style&index=0&id=135eb0eb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports